module.exports = __webpack_public_path__ + "img/icon-advantage-2.46506a57.svg";